import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import './dateinfo.scss'

const DateInfo = ({date, reading, team}) => {
  return (
    <div className="ai_share_date">
      <div className="ai_date_box">
        <CalendarTodayOutlinedIcon
          sx={{ marginRight: "8px", fontSize: "22px" }}
        />{" "}
        {date}
      </div>
      <div className="ai_date_box">
        <AccessTimeOutlinedIcon sx={{ marginRight: "8px", fontSize: "22px" }} />{" "}
        {reading}
      </div>
      <div className="ai_date_box">
        <Groups2OutlinedIcon sx={{ marginRight: "8px", fontSize: "22px" }} />{" "}
        {team}
      </div>
    </div>
  );
};

export default DateInfo;
